<template>
  <ol class="space-y-1">
    <li
      v-for="transaction in transactions"
      :key="transaction.id"
    >
      <Component
        :is="
          transaction.source === 'unlinked'
            ? 'span'
            : 'RouterLink'
        "
        v-bind="getTransactionDetailRoute(transaction)"
        class="bg-background flex w-full flex-row items-center justify-start space-x-2 rounded-lg px-3 py-1 shadow"
        :class="
          transaction.source !== 'unlinked'
            ? 'hover:bg-background-fg/3'
            : ''
        "
      >
        <div>
          <div class="line-clamp-1 text-sm font-semibold">
            {{ transaction.source }}
            <template v-if="transaction.sourceNumber"
              >: #{{ transaction.sourceNumber }}</template
            >
          </div>

          <div class="line-clamp-1 flex items-center">
            <span
              class="text-background-fg/87 mr-1 text-xs"
            >
              {{ formatToDate(transaction.createdAt) }}
            </span>
            <span class="text-sm font-semibold">
              {{ formatToTime(transaction.createdAt) }}
            </span>
          </div>
        </div>

        <div class="flex-1">
          <p
            :class="[
              transaction.status === 'successful'
                ? {
                    payment: 'text-background-fg',
                    refund: 'text-error',
                  }[transaction.type]
                : 'text-black/30',
              'line-clamp-1 text-right font-semibold',
            ]"
          >
            <span class="mr-2 text-sm">{{
              getStatusText(transaction)
            }}</span>

            <template v-if="transaction.type === 'refund'"
              >-</template
            >
            {{
              formatToCurrencyString(
                transaction.amountTransactedTotal,
                transaction.currency
              )
            }}
          </p>
        </div>

        <div class="flex w-16 flex-shrink-0 justify-center">
          <PaymentDetailChip
            :payment="getPaymentMethod(transaction)"
          />
        </div>
      </Component>
    </li>
  </ol>
</template>

<script setup lang="ts">
import type {
  PaymentDetailCard,
  PaymentDetailCash,
} from "@/services/sharedTypes/invoices"
import type { Transaction } from "@/services/transactions/listTransactions"

const props = defineProps<{
  transactions: Transaction[]
}>()

const { formatToCurrencyString } = useCurrency()

const getTransactionDetailRoute = (
  transaction: Transaction
) =>
  transaction.source === "donation"
    ? {
        to: {
          name: "historyDonationDetail",
          params: {
            donationId: transaction.sourceId,
          },
        },
      }
    : transaction.source === "sale"
      ? {
          to: {
            name: "historyOrdersDetail",
            params: {
              orderId: transaction.sourceId,
            },
          },
        }
      : {}

const getPaymentMethod = (
  transaction: Transaction
): PaymentDetailCard | PaymentDetailCash =>
  transaction.transactionMethod === "pos_card"
    ? {
        transactionMethod: transaction.transactionMethod,
        cardScheme: transaction.cardScheme,
        cardNumberLast4: transaction.cardNumberLast4,
      }
    : {
        transactionMethod: transaction.transactionMethod,
      }

const getStatusText = (transaction: Transaction) => {
  return {
    successful: "",
    cancelled: "Cancelled",
    voided: "VOIDED",
    pending: "Pending",
    failed: "Failed",
  }[transaction.status]
}
</script>
